import { createStyles, withStyles, Theme } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

interface LinearProgressBarProps {
    backgroundColor?: string;
}

export default function LinearProgressBar({ backgroundColor }: LinearProgressBarProps) {

    const BorderLinearProgress = withStyles((theme: Theme) =>
        createStyles({
            root: {
                height: 3,
                borderRadius: 20,
            },
            colorPrimary: {
                backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
            },
            bar: {
                borderRadius: 20,
                backgroundColor: backgroundColor || '#005BAE',
            },
        }),
    )(LinearProgress);

    return (
        <BorderLinearProgress />
    )
}
